import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  FilterType,
  UserPermission
} from '@globaleris/ui.library'
import { Card, CardContent, CardHeader, Grid, makeStyles, Paper, useTheme } from '@material-ui/core'
import CloudDownloadRoundedIcon from '@material-ui/icons/CloudDownloadRounded'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EnumFileStateWithDispatch } from '../../api/Pioneer/enums/enumFileStateWithDispatch'
import { enumToSelectOptionArray } from '../../helpers'
import { fileDownloadHelper } from '../../helpers/fileDownloadHelper'
import { regulatoryReportDownloadCard } from './regulatoryReports.Model'
import { downloadRegulatoryReportFile } from './regulatoryReports.service'
import { styles } from './regulatoryReports.styles'

export interface RegulatoryReportsDownloadCardProps {
  data?: regulatoryReportDownloadCard[]
}

export const RegulatoryReportsDownloadCard: React.FC<
  RegulatoryReportsDownloadCardProps
> = props => {
  const [t] = useTranslation(['regulatoryReports', 'enums', 'storageHelper'])

  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  //#region Handlers

  const onDownloadHandler = async (row: regulatoryReportDownloadCard) => {
    const response = await downloadRegulatoryReportFile(row)
    if (response.success && response.data) {
      fileDownloadHelper(response.data.name, response.data)
    }
  }

  //#endregion

  //#region DataTable definition

  const columns: DataTableColumn[] = [
    {
      name: 'fileDate',
      label: t('regulatoryReports:regulatoryReportsDownloadCard.columns.fileDate'),
      type: DataType.DATE
    },
    {
      name: 'actions',
      label: '',
      hideForResponsive: true,
      type: DataType.HTML
    },
    {
      name: 'fileName',
      label: t('regulatoryReports:regulatoryReportsDownloadCard.columns.fileName'),
      type: DataType.TEXT
    },
    {
      name: 'fileRrm',
      label: t('regulatoryReports:regulatoryReportsDownloadCard.columns.fileRrm'),
      type: DataType.TEXT
    },
    {
      name: 'fileState',
      label: t('regulatoryReports:regulatoryReportsDownloadCard.columns.fileState'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(
        EnumFileStateWithDispatch,
        'enums:EnumFileStateWithDispatch'
      )
    }
  ]

  const options: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    elevation: 0,
    filterType: FilterType.ADVANCED,
    download: false,
    print: false,
    selectableRows: false,
    canDelete: false,
    canEdit: false,
    rowCustomActions: [
      {
        userPermission: UserPermission.READ_ONLY,
        icon: <CloudDownloadRoundedIcon fontSize="small" />,
        tooltip: t('regulatoryReports:regulatoryReportsDownloadCard.actions.download'),
        onClick: onDownloadHandler,
        visibleIf: 'canDownload'
      }
    ],
    selectToolbarCustomActions: [
      //   {
      //     userPermission: UserPermission.READ_ONLY,
      //     icon: <CloudDownloadRoundedIcon fontSize="small" />,
      //     tooltip: t('regulatoryReports:regulatoryReportsDownloadCard.actions.download'),
      //     onClick: onDownloadMassiveHandler
      //   }
    ]
    // onFilterChange: (filter: ColumnFilter[]) => {
    //   //storeDataTableFilterForCurrentPage(filter);
    // },
    // onSearchChange: (search: string) => {
    //   //storeDataTableSearchForCurrentPage(search);
    // }
  }

  //#endregion

  return (
    <div className={classes.container}>
      <Grid container>
        <Grid item lg={12}>
          <Paper elevation={6}>
            <Card>
              <CardHeader
                title={t('regulatoryReports:regulatoryReportsDownloadCard.titleDownloadCard')}
              ></CardHeader>
              <CardContent>
                <DataTable
                  data={props.data}
                  columns={columns}
                  options={options}
                  //info={DataTableErrorHandler(errorProps)}
                  //userPermissions={getUserPermissions(Pages.BuyAndSell)}
                  //appliedFilter={dataTableFilter}
                  //appliedSearch={dataTableSearch}
                />
              </CardContent>
            </Card>
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}
